import { render, staticRenderFns } from "./ConfirmationFailedPage.vue?vue&type=template&id=372f36aa&scoped=true"
import script from "./ConfirmationFailedPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationFailedPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationFailedPage.vue?vue&type=style&index=0&id=372f36aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372f36aa",
  null
  
)

export default component.exports